// Simple shop-the-look sizes toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Handle ADD button clicks
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('shop-the-look-add')) {
      e.preventDefault();
      
      const button = e.target;
      const product = button.closest('.shop-the-look-product');
      const imageContainer = product.querySelector('.shop-the-look-product-image');
      
      if (!imageContainer) return;
      
      // Close all other open sizes first
      const currentlyActive = document.querySelector('.shop-the-look-product-image.active');
      if (currentlyActive && currentlyActive !== imageContainer) {
        currentlyActive.classList.remove('active');
        const otherProduct = currentlyActive.closest('.shop-the-look-product');
        const otherButton = otherProduct.querySelector('.shop-the-look-add');
        if (otherButton) {
          otherButton.textContent = 'ADD';
        }
      }
      
      // Toggle current sizes
      if (imageContainer.classList.contains('active')) {
        // Close
        imageContainer.classList.remove('active');
        button.textContent = 'ADD';
      } else {
        // Open
        imageContainer.classList.add('active');
        button.textContent = 'CLOSE';
      }
    }
  });
  
  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.shop-the-look-product')) {
      // Close any open sizes
      const activeImage = document.querySelector('.shop-the-look-product-image.active');
      if (activeImage) {
        activeImage.classList.remove('active');
        const product = activeImage.closest('.shop-the-look-product');
        const button = product.querySelector('.shop-the-look-add');
        if (button) {
          button.textContent = 'ADD';
        }
      }
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeImage = document.querySelector('.shop-the-look-product-image.active');
      if (activeImage) {
        activeImage.classList.remove('active');
        const product = activeImage.closest('.shop-the-look-product');
        const button = product.querySelector('.shop-the-look-add');
        if (button) {
          button.textContent = 'ADD';
        }
      }
    }
  });
  
});
